import styled from 'styled-components';

export const Content = styled.main<{ $isMobile: boolean }>`
  position: fixed;
  inset: 65px 0 0 ${(props) => props.$isMobile ? '0' : '60px'};
  overflow-y: auto;
  background: #f5f6f8;
  color: #1c2d38;
  padding: 40px 36px 72px;

  @media (max-width: 767px) {
    padding: 24px 20px 88px;
  }
`;

export const TutoriaisContainer = styled.div`
  width: 100%;
  max-width: 1080px;
  margin: 0 auto;
`;

export const PageIntro = styled.header`
  margin-bottom: 28px;

  .eyebrow {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: #bc482b;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    margin-bottom: 12px;
  }

  h1 {
    font-size: clamp(24px, 3vw, 32px);
    font-weight: 600;
    letter-spacing: -0.8px;
    line-height: 1.3;
    color: #1c2d38;
    margin: 0 0 12px;
  }

  p {
    max-width: 780px;
    color: #687581;
    font-size: 14px;
    line-height: 1.8;
    margin: 0;
  }
`;

export const TutorialPlayer = styled.section`
  background: #fff;
  padding: 10px;
  border: 1px solid #e4e8ed;
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(28, 45, 56, 0.06);
  scroll-margin-top: 24px;

  iframe {
    display: block;
    width: 100%;
    aspect-ratio: 16 / 9;
    border: 0;
    border-radius: 12px;
    background: #101c24;
  }

  .player-caption {
    padding: 18px 16px 14px;
  }

  .playing-label {
    display: flex;
    align-items: center;
    gap: 7px;
    color: #bc482b;
    font-size: 11px;
    font-weight: 600;
    margin-bottom: 7px;
  }

  .playing-label::before {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #ec6643;
  }

  h2 {
    font-size: 20px;
    font-weight: 600;
    color: #1c2d38;
    margin: 0;
    line-height: 1.5;
  }

  @media (max-width: 767px) {
    padding: 6px;
    border-radius: 14px;
    .player-caption { padding: 14px 10px; }
    h2 { font-size: 17px; }
  }
`;

export const LibraryHeading = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin: 38px 0 20px;

  h2 {
    font-size: 20px;
    font-weight: 600;
    margin: 0 0 5px;
    color: #1c2d38;
  }

  p { margin: 0; color: #687581; font-size: 13px; }

  .video-count {
    flex-shrink: 0;
    padding: 6px 12px;
    background: #e9edf1;
    border-radius: 20px;
    font-size: 12px;
    color: #52616e;
  }

  @media (max-width: 480px) {
    align-items: flex-start;
    h2 { font-size: 18px; }
  }
`;

export const RowDiv = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;

  @media (max-width: 980px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 18px;
  }

  @media (max-width: 560px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;
